export default __webpack_public_path__ + "static/media/Cuirass of the Fallen Empire (nm).65ebd690.jpg";